import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Select } from 'antd';
import classNames from 'classnames';

import { translate } from 'utils/index';
import { getProfileVendors } from 'api/vendor';
import { vendorStatuses } from 'components/AddFilterButton/lib';

import Filter from './filter';
import FilterType from './filterType';
import FilterVendor from './filterVendor';
import FilterGroup from './filterGroup';
import FilterParentOrganization from './filterParentOrganization';
import { setPagination } from '../../reducers';
import { selectFilters } from '../../selectors';
import { vendorRisk } from '../lib';
import { messages } from '../messages';
import './index.scss';

const { Option } = Select;

const VendorsFilters = ({ callback, className }) => {
  const filters = useSelector(selectFilters);
  const dispatch = useDispatch();

  if (filters.length === 0) {
    return null;
  }

  const fetchVendors = () => {
    return (
      callback ||
      (() => {
        dispatch(setPagination({ current: 1 }));
        dispatch(getProfileVendors());
      })
    );
  };

  return (
    <div className={classNames('vendors-filters', className)}>
      {filters?.map((filter) => {
        const generalProps = {
          key: filter.type,
          filter,
          fetchVendors: fetchVendors(),
        };

        switch (filter.type) {
          case 'vendor-risk-filter':
            return (
              <Filter {...generalProps} innerLabel={translate(messages.filterVendorRisk)}>
                {vendorRisk?.map(({ name, value }) => (
                  <Option key={value} value={translate(name)} id={value}>
                    {translate(name)}
                  </Option>
                ))}
              </Filter>
            );
          case 'vendor-status-filter':
            return (
              <Filter {...generalProps} innerLabel={translate(messages.filterVendorStatus)}>
                {vendorStatuses?.map(({ name, value }) => (
                  <Option key={value} value={translate(name)} id={value}>
                    {translate(name)}
                  </Option>
                ))}
              </Filter>
            );
          case 'company-filter':
            return <FilterVendor {...generalProps} />;
          case 'assessment-filter':
            return <FilterType {...generalProps} />;
          case 'profile-relation-group-filter':
            return <FilterGroup {...generalProps} />;
          case 'parent-organization-filter':
            return <FilterParentOrganization {...generalProps} />;
          default:
            return null;
        }
      })}
    </div>
  );
};

VendorsFilters.propTypes = {
  callback: PropTypes.func,
  className: PropTypes.string,
};

export default VendorsFilters;
